/**
 * Единая ссылка «скачать приложение» для QR и баннеров: Android уходит в Google Play,
 * iPhone и iPad — в App Store, десктоп видит страницу с QR и бейджами.
 * Адрес напечатан в QR — не менять.
 */
export const APP_DOWNLOAD_PATH = '/app/';

export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=ru.vetsy.app';

export const APP_STORE_URL = 'https://apps.apple.com/ru/app/vetsy/id6812984398';

export const APP_STORE_BADGES = [
  {
    id: 'googleplay',
    name: 'Google Play',
    url: PLAY_STORE_URL,
    badge: '/images/vetsy-app-play-badge.png',
  },
  {
    id: 'appstore',
    name: 'App Store',
    url: APP_STORE_URL,
    badge: '/images/vetsy-app-store-badge.svg',
  },
] as const;

export type AppStoreBadge = (typeof APP_STORE_BADGES)[number];
export type AppStoreId = AppStoreBadge['id'];

export function isAndroidUserAgent(userAgent: string | null | undefined): boolean {
  return /android/i.test(userAgent ?? '');
}

export function isIosUserAgent(userAgent: string | null | undefined): boolean {
  return /iPhone|iPad|iPod/i.test(userAgent ?? '');
}

export function storeUrlForUserAgent(userAgent: string | null | undefined): string | null {
  if (isAndroidUserAgent(userAgent)) {
    return PLAY_STORE_URL;
  }

  if (isIosUserAgent(userAgent)) {
    return APP_STORE_URL;
  }

  return null;
}
